/**
 * Copyright (c) 2022 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */

export let UserCredentialStatus = /*#__PURE__*/function (UserCredentialStatus) {
  UserCredentialStatus["APPROVED"] = "APPROVED";
  UserCredentialStatus["EXPIRED"] = "EXPIRED";
  UserCredentialStatus["NEW"] = "NEW";
  UserCredentialStatus["REJECTED"] = "REJECTED";
  return UserCredentialStatus;
}({});
export let UserCredentialType = /*#__PURE__*/function (UserCredentialType) {
  UserCredentialType["BACKGROUND_CHECK"] = "BACKGROUND_CHECK";
  UserCredentialType["CLOSING_AGENT_LICENSE"] = "CLOSING_AGENT_LICENSE";
  UserCredentialType["DIGITAL_CERTIFICATE"] = "DIGITAL_CERTIFICATE";
  UserCredentialType["EO_INSURANCE"] = "EO_INSURANCE";
  UserCredentialType["GENERAL_COMMISSION"] = "GENERAL_COMMISSION";
  UserCredentialType["INITIALS"] = "INITIALS";
  UserCredentialType["RON_COMMISSION"] = "RON_COMMISSION";
  UserCredentialType["SEAL"] = "SEAL";
  UserCredentialType["SIGNATURE"] = "SIGNATURE";
  UserCredentialType["SIGNING_AGENT_CERTIFICATE"] = "SIGNING_AGENT_CERTIFICATE";
  UserCredentialType["SURETY_BOND_CERTIFICATE"] = "SURETY_BOND_CERTIFICATE";
  return UserCredentialType;
}({});
export let CredentialReviewType = /*#__PURE__*/function (CredentialReviewType) {
  CredentialReviewType["APPROVE"] = "APPROVE";
  CredentialReviewType["REJECT"] = "REJECT";
  return CredentialReviewType;
}({});
export let NotaryStatus = /*#__PURE__*/function (NotaryStatus) {
  NotaryStatus["ACTIVE"] = "ACTIVE";
  NotaryStatus["EXPIRED"] = "EXPIRED";
  NotaryStatus["NEW"] = "NEW";
  NotaryStatus["REJECTED"] = "REJECTED";
  NotaryStatus["TERMINATED"] = "TERMINATED";
  NotaryStatus["UNDER_REVIEW"] = "UNDER_REVIEW";
  return NotaryStatus;
}({});
export let UserEventType = /*#__PURE__*/function (UserEventType) {
  UserEventType["SUBMIT_FOR_APPROVAL"] = "SUBMIT_FOR_APPROVAL";
  UserEventType["UPDATE_STATUS"] = "UPDATE_STATUS";
  return UserEventType;
}({});
export const CredentialAttrKeys = {
  [UserCredentialType.GENERAL_COMMISSION]: ['commissionNumber', 'state', 'expirationDate'],
  [UserCredentialType.RON_COMMISSION]: ['ronCommissionNumber', 'state', 'expirationDate'],
  [UserCredentialType.CLOSING_AGENT_LICENSE]: ['certificateNumber', 'expirationDate'],
  [UserCredentialType.DIGITAL_CERTIFICATE]: ['issuer', 'subject', 'expirationDate'],
  [UserCredentialType.EO_INSURANCE]: ['insuranceCoverage', 'expirationDate'],
  [UserCredentialType.SIGNING_AGENT_CERTIFICATE]: ['nnaProfileUrl', 'examPassDate', 'backgroundCheck'],
  [UserCredentialType.SURETY_BOND_CERTIFICATE]: ['suretyBondAmount', 'expirationDate'],
  [UserCredentialType.SEAL]: ['expirationDate'],
  [UserCredentialType.SIGNATURE]: ['expirationDate'],
  [UserCredentialType.INITIALS]: ['expirationDate'],
  [UserCredentialType.BACKGROUND_CHECK]: ['backgroundCheckPassDate']
};
export const CredentialTypeNames = {
  [UserCredentialType.BACKGROUND_CHECK]: 'NNA Background Check Results',
  [UserCredentialType.CLOSING_AGENT_LICENSE]: 'Closing Agent License (if applicable)',
  [UserCredentialType.DIGITAL_CERTIFICATE]: 'Digital Certificate',
  [UserCredentialType.EO_INSURANCE]: 'Errors & Omissions Insurance (if applicable)',
  [UserCredentialType.GENERAL_COMMISSION]: 'Notary Certificate/General Commission',
  [UserCredentialType.INITIALS]: 'Electronic Digital Initials',
  [UserCredentialType.RON_COMMISSION]: 'RON Commission (if applicable)',
  [UserCredentialType.SEAL]: 'Electronic Notary Seal',
  [UserCredentialType.SIGNATURE]: 'Electronic Digital Signature',
  [UserCredentialType.SIGNING_AGENT_CERTIFICATE]: 'NNA Signing Agent Certificate',
  [UserCredentialType.SURETY_BOND_CERTIFICATE]: 'Surety Bond Certificate (if applicable)'
};
export const CredentialAttrMeta = {
  backgroundCheckPassDate: {
    label: 'Background check passed date',
    pastDate: true,
    required: true,
    type: 'date'
  },
  certificateNumber: {
    label: 'Notary certificate/Commission number',
    required: true,
    type: 'text'
  },
  commissionNumber: {
    label: 'General Commission number',
    required: true,
    type: 'text'
  },
  examPassDate: {
    label: 'Certificate exam pass date',
    pastDate: true,
    required: true,
    type: 'date'
  },
  expirationDate: {
    futureDate: true,
    label: 'Expiration date',
    required: true,
    type: 'date'
  },
  insuranceCoverage: {
    label: 'Insurance coverage',
    required: true,
    type: 'number'
  },
  issuer: {
    label: 'Issuer',
    required: false,
    type: 'text'
  },
  ronCommissionNumber: {
    label: 'RON Commission number',
    required: true,
    type: 'text'
  },
  state: {
    label: 'State',
    required: true,
    type: 'text'
  },
  subject: {
    label: 'Subject',
    required: false,
    type: 'text'
  },
  suretyBondAmount: {
    label: 'Surety bond amount',
    required: true,
    type: 'number'
  },
  nnaProfileUrl: {
    label: 'URL of your profile on NNA',
    required: false,
    type: 'text'
  },
  backgroundCheck: {
    label: 'Background check result',
    required: false,
    type: 'text'
  }
};
export const NotaryStatusText = {
  [NotaryStatus.NEW]: 'Invited',
  [NotaryStatus.UNDER_REVIEW]: 'Under review',
  [NotaryStatus.EXPIRED]: 'Expired',
  [NotaryStatus.ACTIVE]: 'Approved',
  [NotaryStatus.REJECTED]: 'Rejected',
  [NotaryStatus.TERMINATED]: 'Terminated'
};
export const ImageExtensions = ['.png', '.jpg', '.jpeg'];